
<f-dialog
    v-if         = "contract"
    v-model      = "edit"
    :show-header = false
    :width       = "900"

    @cancel = "onCancel"
    @store  = "onSave"
>
    <template v-slot:content>
        <v-form ref="form">
            <v-row class="no-frame mt-2">
                <v-col class="no-frame col-6 pr-2">
                    <c-column-header
                        class="primary mb-1"
                        :label="$t('contract.title') + ' ' + title"
                    >
                        <template v-slot:filter>
                            <div class="contract-active">
                                <v-checkbox
                                    v-model = "contract.active"
                                    label   = "aktiv"
                                    :ripple = "false"
                                    color   = "primary"
                                    class="ma-0 pa-0"
                                    hide-details
                                />
                            </div>
                        </template>
                    </c-column-header>

                    <v-row class="no-frame lm-border pa-3 pt-0 mt-0">
                        <v-col class="no-frame">
                            <c-contract-header
                                :contract      = "contract"
                                :show-customer = "showCustomer"
                                :show-title    = "false"
                                :readonly      = "false"
                                class          = "pt-2"
                            >
                                <template v-slot:add>
                                    <slot name="add"></slot>
                                </template>
                                <template v-slot:post>
                                    <slot name="post"></slot>
                                </template>
                            </c-contract-header>
                        </v-col>
                    </v-row>

                    <div class="pt-0 mt-3">
                        <div class="h-100">
                            <slot name="terms" />
                        </div>
                    </div>

                </v-col>
                <v-col class="no-frame col-6 mt-0 pl-2">
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <c-column-header
                                class="primary mt-0"
                                :label="$t('contract.payment.title') "
                            >
                                <template v-slot:filter>
                                    <div class="contract-active">
                                        <v-checkbox
                                            v-model   = "contract.invoiceInAdvance"
                                            label     = "im Voraus"
                                            :ripple   = "false"
                                            class="ma-0 pa-0"
                                            hide-details
                                        />
                                    </div>
                                </template>
                            </c-column-header>

                            <c-contract-payment
                                :contract   = "contract"
                                :show-title = "false"
                                :readonly   = "false"
                                class=" lm-border pa-3 pt-2 mt-1"
                                style="height: 162px;"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <c-column-header
                                class="primary mt-2"
                                :label="$t('contract.termsOfCancelation') "
                            />
                            <c-contract-toc
                                :contract = "contract"
                                :readonly = "false"
                                :show-title = "false"
                                class=" lm-border pa-3 pt-2 mt-1"
                                style     = "height: 230px;"
                            />
                        </v-col>
                    </v-row>

                </v-col>
            </v-row>
        </v-form>
    </template>
</f-dialog>
